import React, { useState } from "react";
import { Button, Drawer } from "antd";

// import div from "react-bootstrap/div";
// import div from "react-bootstrap/div";
import { Container } from "react-bootstrap";
import PersonIcon from "@mui/icons-material/Person";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import CoinIcon from "../../../assets/images/coin-icon.png";
import PayWallet from "../../../assets/images/icon-wallet.png";
import SaveCard from "../../../assets/images/icon-saved-card.png";
import Booking from "../../../assets/images/icon-mybooking.png";
import Account from "../../../assets/images/icon-user.png";
import CoDriver from "../../../assets/images/icon-codriver.png";
import { Link } from "react-router-dom";

const DrawerMenu = () => {
  const [visible, setVisible] = useState(false);

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };
  return (
    <div class="login">
      <div className="sidemenu-wrap ">
        <Button type="primary" className="sidemenu" onClick={showDrawer}>
          <span></span>
          <span></span>
          <span></span>
        </Button>

        <div className="side-menu-drawer-wrap">
          <Drawer
            title="Basic Drawer"
            placement="right"
            onClose={onClose}
            visible={visible}
            className="drawer "
          >
            <div className="sidemenu-main-header no-gutters ">
              <div>
                <div className="top-content">
                  <div className="left-content">
                    <div class="Digant-Bhatt">Digant Bhatt</div>
                    <div>9974920002</div>
                    <div class="bhattdigantgmailcom">
                      bhatt.digant@gmail.com
                    </div>
                  </div>
                  <div className="right-icon-content">
                    <PersonIcon className="person-icon" />
                  </div>
                </div>
              </div>
            </div>

            <div
              className="mid-content no-gutters"
              style={{ padding: "0px 30px" }}
            >
              <div className="main-items">
                <div className="item-left">
                  <Link to="/documentupload">Profile Documents</Link>
                </div>

                <div className="profile-icn">
                  <CloseIcon style={{ color: " red" }} />
                </div>
              </div>

             

              {/* <div className="main-items">
                <Link to="/credits" className="item-left">
                  Credits
                </Link>
                {/* <div className="item-left">Credits</div> */}

                {/* <div className="item-right">
                  <img src={CoinIcon} alt="coin-icon" />
                </div>
              </div>  */}

              

            

              <div className="main-items">
                <div className="item-left">
                  <Link to="/mybooking">My Bookings</Link>
                </div>

                <div className="item-right">
                  <img src={Booking} alt="booking" />
                </div>
              </div>
           
              <div className="main-items">
                <Link to="/myaccount" className="item-left">
                  Account
                </Link>

                <div className="item-right">
                  <img src={Account} alt="account" />
                </div>
              </div>
              <div className="main-items">
                <Link to="/codriver" className="item-left">
                  Co-Driver
                </Link>
                {/* <div className="item-left">Co-Driver</div> */}

                <div md={6} className="item-right">
                  <img src={CoDriver} alt="co-driver" />
                </div>
              </div>

              <div className="border-drawer-wrap"></div>

              <div className="main-items">
                <Link to="/policycontent" className="item-left">
                  Vehicles & Policy
                </Link>
                {/* <div className="item-left">Vehicles & Policy</div> */}
              </div>
              <div className="main-items">
                <Link to="/help" className="item-left">
                  Help & Support
                </Link>
                {/* <div className="item-left">Help & Support</div> */}
              </div>
              <div className="main-items">
                <div className="item-left">
                  <Link to="/termsconditons">terms & conditions</Link>
                </div>
              </div>
            </div>
          </Drawer>
        </div>

        {/* <Drawer
          className="drawer "
          title={null}
          header={null}
          placement="right"
          onClose={onClose}
          visible={visible}
          closeIcon={visible}
        >
          <div className="sidemenu-main-header no-gutters ">
            <div>
              <div className="top-content">
                <div className="left-content">
                  <div class="Digant-Bhatt">Digant Bhatt</div>
                  <div>9974920002</div>
                  <div class="bhattdigantgmailcom">bhatt.digant@gmail.com</div>
                </div>
                <div className="right-icon-content">
                  <PersonIcon className="person-icon" />
                </div>
              </div>
            </div>
          </div>

          <div
            className="mid-content no-gutters"
            style={{ padding: "0px 30px" }}
          >
            <div className="main-items">
            <div className="item-left">

            <Link to="/documentupload">Profile Documents</Link>
            </div>

              <div className="profile-icn">
                <CloseIcon style={{ color: " red" }} />
              </div>
            </div>

            <div className="main-items">
              <div className="item-left">paytm Wallet</div>

              <div className="profile-icn">
                <DoneIcon style={{ color: " green" }} />
              </div>
            </div>

            <div className="main-items">
              <div className="item-left">Credits</div>

              <div className="item-right">
                <img src={CoinIcon} alt="coin-icon" />
              </div>
            </div>

            <div className="main-items">
              <div className="item-left">Paytm Wallet</div>

              <div className="item-right">
                <img src={PayWallet} alt="wallet" />
              </div>
            </div>
            <div className="main-items">
              <div className="item-left">
                <Link to="/mybooking">My Bookings</Link>
              </div>

              <div className="item-right">
                <img src={Booking} alt="booking" />
              </div>
            </div>
            <div className="main-items">
              <div className="item-left">Saved Cards</div>

              <div className="item-right">
                <img src={SaveCard} alt="saved-card" />
              </div>
            </div>
            <div className="main-items">
              <Link to="/myaccount" className="item-left">Account</Link>

              <div className="item-right">
                <img src={Account} alt="account" />
              </div>
            </div>
            <div className="main-items">
              <div className="item-left">Co-Driver</div>

              <div md={6} className="item-right">
                <img src={CoDriver} alt="co-driver" />
              </div>
            </div>

            <div className="border-drawer-wrap">
              
            </div>

            <div className="main-items">
              <div className="item-left">Vehicles & Policy</div>
            </div>
            <div className="main-items">
              <div className="item-left">Help & Support</div>
            </div>
            <div className="main-items">
          
              <div className="item-left">
              <Link to="/termsconditons" >terms & conditions</Link>
              </div>
            </div>
          </div>
        </Drawer> */}
      </div>
    </div>
  );
};

export default DrawerMenu;
